export default "__VITE_ASSET__Br4yl57E__"